import { TableColumn } from '/@/modules/core/table/models/TableColumn';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export const CellMixin = {
  props: {
    cellData: { type: [String, Number, Object, Array, Boolean] },
    rowData: { type: [BaseEntityModel, Object] },
    column: { type: TableColumn },
    tableId: { type: String }
  }
};
